import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery, useMutation, useQueryClient } from "react-query";
import env from "../../environment";

export function useLOSDetail({ ibo }) {
  const { data, isLoading, refetch } = useQuery(
    ["los", ibo],
    () =>
      makeAuthedRequest(
        `/los/ibo/${ibo}`,
        {
          method: "GET",
        },
        env.apiBaseNew
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!ibo,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
